import React, {useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import '../assets/css/CustomNavbar.css'
import {FaBars, FaTimes} from "react-icons/fa";
import OpsText from "../ops-library/ops-text";
import OpsBtn from "../ops-library/ops-btn";
import {FaInstagram} from "react-icons/fa";
import {FaFacebookSquare} from "react-icons/fa";
import {FaYoutube} from "react-icons/fa";
import {ACCESS_TOKEN_KEY} from "../constants/constants";
import {isTokenExpired} from "../functions/isTokenExpired";

const CustomNavbar = ({socialUrls}) => {

    const [menuOpen, setMenuOpen] = useState(false);
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);
    const navigate = useNavigate();
    const location = useLocation();

    const scrollToSection = (id) => {
        if (menuOpen) setMenuOpen(false)

        const navbarHeight = document.querySelector(".navbar-container")?.offsetHeight || 0;
        const isMobile = window.innerWidth <= 1069;

        if (id === 'admin') {
            navigate("/admin", {replace: true});
        } else if (location.pathname !== "/") {
            navigate("/", {replace: true});
            setTimeout(() => {
                const element = document.getElementById(id);
                if (element) {
                    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
                    const offset = isMobile ? navbarHeight + 10 : 0; // Posun iba na mobile
                    window.scrollTo({top: elementPosition - offset, behavior: "smooth"});
                }
            }, 500);
        } else {
            const element = document.getElementById(id);
            if (element) {
                const elementPosition = element.getBoundingClientRect().top + window.scrollY;
                const offset = isMobile ? navbarHeight + 10 : 0; // Posun iba na mobile
                window.scrollTo({top: elementPosition - offset, behavior: "smooth"});
            }
        }
    };

    const NavBtn = ({btnTitle, sectionID}) => {
        return (
            <OpsBtn
                btnText
                text={btnTitle}
                textColor="color-1 txt-normal3"
                textStyle="text-center font-500 menu-item-text mt-2"
                action={() => scrollToSection(sectionID)}
            />
        )
    }

    return (
        <div className="navbar-container">
            <div className="navbar-title fa-flex-col justify-content-center py-2" onClick={() => navigate("/")}>
                <OpsText type="navbar-title px-1 mb-neg3" weight="tillana-300" color="primary-5"
                         content="Beťarky"/>
                <OpsText type="navbar-subtitle px-1" weight="tillana-300" color="secondary-1"
                         content="Ľudová hudba"/>
            </div>

            <div className="navbar-buttons gap-2">
                <div className="navbar-social fa-w-100 fa-flex-row justify-content-end gap-1">
                    <OpsBtn
                        icon={<FaFacebookSquare color="color-1" className="ops-icon-navbar m-1"/>}
                        variant="icon m-1 p-1 bg-black"
                        padding={false}
                        action={() => window.open(socialUrls.fbUrl, "_blank", "noreferrer")}
                    />
                    <OpsBtn
                        icon={<FaInstagram color="color-1" className="ops-icon-navbar m-1"/>}
                        variant="icon m-1 p-1 bg-black"
                        padding={false}
                        action={() => window.open(socialUrls.igUrl, "_blank", "noreferrer")}
                    />
                    <OpsBtn
                        icon={<FaYoutube color="color-1" className="ops-icon-navbar m-1"/>}
                        variant="icon m-1 p-1 bg-black"
                        padding={false}
                        action={() => window.open(socialUrls.ytUrl, "_blank", "noreferrer")}
                    />
                    <OpsBtn
                        icon={menuOpen ? <FaTimes color="color-1" className="ops-icon-navbar m-1"/> :
                            <FaBars color="color-1" className="ops-icon-navbar m-1"/>}
                        variant="icon m-1 p-1 bg-black mobile-menu-icon ms-3"
                        padding={false}
                        action={() => setMenuOpen(!menuOpen)}
                    />
                </div>

                <div className="navbar-menu-buttons fa-flex-col fa-w-100 py-1 gap-2">
                    <NavBtn sectionID="home" btnTitle={"Domov"}/>
                    <NavBtn sectionID="information" btnTitle={"O nás"}/>
                    <NavBtn sectionID="concerts" btnTitle={"Koncerty"}/>
                    <NavBtn sectionID="product" btnTitle={"CD"}/>
                    <NavBtn sectionID="actualities" btnTitle={"Aktuality"}/>
                    <NavBtn sectionID="gallery" btnTitle={"Galéria"}/>
                    <NavBtn sectionID="review" btnTitle={"Recenzia"}/>
                    <NavBtn sectionID="contact" btnTitle={"Kontakt"}/>
                    {!isTokenExpired(token) &&
                        <NavBtn sectionID="admin" btnTitle={"Admin"}/>}
                </div>

                {/* MOBILE DROPDOWN MENU */}
                {menuOpen && (
                    <div className="menu-dropdown gap-2 p-3">
                        <NavBtn sectionID="home" btnTitle="Domov"/>
                        <NavBtn sectionID="information" btnTitle="O nás"/>
                        <NavBtn sectionID="concerts" btnTitle="Koncerty"/>
                        <NavBtn sectionID="product" btnTitle="Objednávka CD"/>
                        <NavBtn sectionID="actualities" btnTitle="Aktuality"/>
                        <NavBtn sectionID="gallery" btnTitle="Galéria"/>
                        <NavBtn sectionID="review" btnTitle="Recenzia"/>
                        <NavBtn sectionID="contact" btnTitle="Kontakt"/>
                        {!isTokenExpired(token) &&
                            <NavBtn sectionID="admin" btnTitle={"Admin"}/>}
                    </div>
                )}
            </div>
        </div>
    )
};

export default CustomNavbar;